// src/helpers/factories/settings/usersCardFactory.ts
var usersCardFactory = (users) => Object.values(users).map(
  (user) => ({
    id: user.organizationUserId,
    title: `${user.user.firstName} ${user.user.lastName}`,
    email: user.user.email,
    isActive: user.active,
    roleIds: user.roleIds,
    locationsCount: user.locationIds.length,
    activeFilter: user.active ? 1 : 2
  })
);

export { usersCardFactory };
